import { Cell, styled } from '@zeiss/beyond-online-react';
import { Box, Grid } from '@zeiss/lib-components';

import { BaseProps } from './';
import { ApplicationCard } from 'src/modules/TenantManagement/components/ApplicationCard';
import { ApplicationSearch } from 'src/modules/TenantManagement/components/ApplicationSearch';
import { Application } from 'src/types/tenantManagement';

// Autocomplete has a hard coded wrapper which has smaller height than Text Input.
// To prevent button jumping between steps, Autocomplete has to be wrapped into an extra Container.
const Container = styled.div`
  margin-bottom: 26px;
`;

export const Applications = ({
  setState,
  state: { applications },
}: BaseProps) => {
  const onDismiss = (id: string) => {
    setState((prev) => ({
      ...prev,
      applications: prev.applications.filter((item) => item.id !== id),
    }));
  };

  const onSelectApplication = (application: Application) => {
    setState((prev) => ({
      ...prev,
      applications: [...prev.applications, application],
    }));
  };

  return (
    <Container>
      <Box>
        <Grid>
          <Cell.Basic colSpan={[4, 6, 5]}>
            <ApplicationSearch
              onSelectApplication={onSelectApplication}
              selectedApplications={applications}
            />
          </Cell.Basic>
        </Grid>
      </Box>

      {applications.length ? (
        <Box>
          <Grid>
            {applications.map(({ id, name, zeissDepartment }) => (
              <Cell.Basic colSpan={[4, 6, 5, 4]} key={id}>
                <ApplicationCard
                  department={zeissDepartment}
                  id={id}
                  name={name}
                  onDismiss={onDismiss}
                />
              </Cell.Basic>
            ))}
          </Grid>
        </Box>
      ) : null}
    </Container>
  );
};
